import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  TextField,
  MenuItem,
  CircularProgress,
  Autocomplete,
} from '@mui/material';
import apiService from '../../../actions/services';


const TrasladoBodegaCocina = () => { 
  
const dispatch = useDispatch();
  const { user } = useSelector(state => state.auth);  
  const [searchValue, setSearchValue] = useState('');
  const [transferQuantity, setTransferQuantity] = useState(0);
  const [availableItemsTSCR, setAvailableItemsTSCR] = useState([]);
  const [availableItemsCCO, setAvailableItemsCCO] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false); 
  const [bodegaSeleccionada, setBodegaSeleccionada] = useState('');
  const [comentario, setComentario] = useState('');


  const tiendasPrecargadas = [
    { id: 1, nombre: 'TZ10' },
    { id: 2, nombre: 'TPRR' },
    { id: 3, nombre: 'TSCR' },
    { id: 4, nombre: 'TCSV' },
    { id: 5, nombre: 'TMIR' },
    { id: 6, nombre: 'TXLA' }
  ];


  // Función para obtener datos de productos por bodega
  const fetchData = (bodega, setFunction) => {
    const datos = {
      Token:
        'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'SAMSUNG',
        Modelo: 'S22002B',
        Version: 'Android 18.125',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '321|-485|321',
      },
      Usr: {
        Codigo: '',
        UserNickName: 'pierril',
      },
      DatosMetodo: {
        NombreMetodo: 'ListaProductosExistenciaSalas',
        Datos_Recibidos: `{ "BODEGA": "${bodega}" }`,
      },
    };

    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(
      JSON.stringify(datos)
    )}`;

    fetch(fetchDataUrl)
      .then((response) => response.json())
      .then((data) => {
        try {
          const decodedString = JSON.parse(data.datos_Generados);
          console.log(data.datos_Generados)
          const stockData = decodedString.STOCK.map((item) => ({
            codigo: item['Código del Producto'],
            descripcion: item['Nombre del Producto'],
            cantidadDisponible: item['Stock Disponible'],
            cantidadCCO: item['Stock Disponible Cocina'],
            Bodega: item['Bodega']
          }));
          setFunction(stockData);
        } catch (error) {
          console.error('Error al procesar datos_Generados:', error);
        }
      })
      .catch((error) => console.error('Error en la solicitud:', error));
  }; 
  const getBodegasFiltradas = () => {
    if (tiendasPrecargadas.some(tienda => tienda.nombre === user.usuario)) {
      // Si coincide con una tienda, excluirla de la lista
      return tiendasPrecargadas.filter(tienda => tienda.nombre !== user.usuario);
    }
    // Si no coincide, mostrar todas las bodegas
    return tiendasPrecargadas;
  };
  

  // Obtener datos al montar el componente
  useEffect(() => {
    if (bodegaSeleccionada) {
      fetchData(bodegaSeleccionada, setAvailableItemsTSCR);
      fetchData(`${bodegaSeleccionada}-CCO`, setAvailableItemsCCO);
    }
  }, [bodegaSeleccionada]);
  
  useEffect(() => {
    const bodegaInicial = tiendasPrecargadas.find(tienda => tienda.nombre === user.usuario);
    if (bodegaInicial) {
      setBodegaSeleccionada(bodegaInicial.nombre);
    }
    const dat = {};
    apiService.logactivity('trasladoCocina.jsx','',dat,user);
  }, [user]);
  
  const usuarioEnTiendasPrecargadas = tiendasPrecargadas.some(
    (tienda) => tienda.nombre === user.usuario
  );
  // Agregar producto a la lista seleccionada
  const handleAdd = () => {
    const itemToAdd = availableItemsTSCR.find(
      (item) => item.codigo === searchValue
    );
    if (
      itemToAdd &&
      transferQuantity > 0 &&
      transferQuantity <= itemToAdd.cantidadDisponible
    ) {
      setSelectedItems([
        ...selectedItems,
        { ...itemToAdd, cantidadTransferida: transferQuantity },
      ]);
      setAvailableItemsTSCR(
        availableItemsTSCR.map((item) =>
          item.codigo === searchValue
            ? {
                ...item,
                cantidadDisponible: item.cantidadDisponible - transferQuantity,
              }
            : item
        )
      );
      setSearchValue('');
      setTransferQuantity(0);
    }
  };
  // remove  
  const handleRemove = (codigo) => {
    // Encuentra el elemento a remover en selectedItems
    const itemToRemove = selectedItems.find((item) => item.codigo === codigo);
  
    if (itemToRemove) {
      // Actualiza los items disponibles en TSCR, devolviendo la cantidad transferida
      setAvailableItemsTSCR((prevAvailableItems) =>
        prevAvailableItems.map((item) =>
          item.codigo === codigo
            ? {
                ...item,
                cantidadDisponible: item.cantidadDisponible + itemToRemove.cantidadTransferida,
                Bodega: item.Bodega
              }
            : item
        )
      );
  
      // Filtra la lista de seleccionados para eliminar el ítem
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((item) => item.codigo !== codigo)
      );
    }
  };
  


  // Enviar productos seleccionados
  const handleSend = () => {
    setIsLoading(true);
  
    // 1. Agrupar productos por su Bodega (item.Bodega)
    const productosAgrupados = selectedItems.reduce((acc, item) => {
      const bodegaItem = item.Bodega; // La bodega específica del ítem
      if (!acc[bodegaItem]) {
        acc[bodegaItem] = [];
      }
      acc[bodegaItem].push({
        ItemCode: item.codigo,
        Quantity: item.cantidadTransferida,
        Bodegaloc: item.Bodega // Conservamos la bodega del ítem
      });
      return acc;
    }, {});
  
    // 2. Preparar las transferencias (una por grupo de bodega)
    const promesas = Object.entries(productosAgrupados).map(([bodegaItem, productos]) => {
      const datos = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321',
        },
        User: {
          Codigo: '',
          UserNickName: 'pierril',
        },
        Metodo: {
          NombreMetodo: 'StockTransfer',
          Datos_Recibidos: JSON.stringify({
            Series: null,
            BodegaOrigen: bodegaItem, // Ahora usamos la bodega del grupo actual (bodegaItem)
            BodegaDestino: bodegaSeleccionada + '-CCO', // Fija, basada en la selección
            Comentarios: comentario,
            Productos: productos
          }),
          Datos_Generados: '',
        },
      };
  
      return fetch('https://appcorp.parma.com.gt/API/ReceptorDatos', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datos),
      })
      .then(response => response.json())
      .then(data => ({
        grupoBodega: bodegaItem,
        success: true,
        message: data.datos_Generados || 'Transferencia exitosa',
        data: data
      }))
      .catch(error => ({
        grupoBodega: bodegaItem,
        success: false,
        message: 'Error en transferencia: ' + error.message,
        error: error
      }));
    });
  
    // 3. Procesar todas las respuestas
    Promise.all(promesas)
      .then(results => {
        const mensaje = results.map(r => 
          `Productos de bodega ${r.grupoBodega}: ${r.message}`
        ).join('\n\n');
        
        alert(`Resultado de transferencias:\n\n${mensaje}`);
        
        if (results.every(r => r.success)) {
          setSelectedItems([]);
          window.location.reload();
        }
      })
      .catch(error => {
        console.error('Error general:', error);
        alert('Error al procesar las transferencias');
      })
      .finally(() => setIsLoading(false));
  };
  

  return ( 
    
    <div style={{ padding: '1rem' }}>
      {/* Div contenedor para Buscar y Agregar */} 
      <div style={{ padding: '1rem' }}>
    {/* Solo mostrar si el usuario NO está en tiendasPrecargadas */}
    {!usuarioEnTiendasPrecargadas && (
      <div style={{ marginBottom: '1rem' }}>
        <h3>Seleccionar Bodega</h3>
        <TextField
          select
          label="Bodega"
          value={bodegaSeleccionada}
          onChange={(e) => setBodegaSeleccionada(e.target.value)}
          style={{ width: '300px' }}
        >
          {/* Aquí irían las opciones */}
		    {getBodegasFiltradas().map((bodega) => (
      <MenuItem key={bodega.id} value={bodega.nombre}>
        {bodega.nombre}
      </MenuItem>
    ))}
        </TextField>
      </div>
    )}
  </div>

  <div style={{ marginBottom: '1rem' }}>
  <h3>Búsqueda y Agregar</h3>
  <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
    <Autocomplete
      options={availableItemsTSCR}
      getOptionLabel={(option) => `${option.codigo} - ${option.descripcion} - ${option.cantidadDisponible} - U`}
      value={availableItemsTSCR.find((item) => item.codigo === searchValue) || null}
      onChange={(event, newValue) => {
        setSearchValue(newValue ? newValue.codigo : '');
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Buscar producto"
          variant="outlined"
          style={{ width: '700px' }}
        />
      )}
      filterOptions={(options, state) => {
        return options.filter(
          (option) =>
            option.codigo.toLowerCase().includes(state.inputValue.toLowerCase()) ||
            option.descripcion.toLowerCase().includes(state.inputValue.toLowerCase())
        );
      }}
    />

    <TextField
      type="number"
      label="Cantidad a transferir"
      value={transferQuantity}
      onChange={(e) => setTransferQuantity(Number(e.target.value))}
      style={{ width: '150px' }}
    />
    <TextField
      label="Escribe un comentario"
      value={comentario}
      onChange={(e) => setComentario(e.target.value)}
      style={{ width: '250px' }}
    />
    <Button variant="contained" color="primary" onClick={handleAdd}>
      Agregar
    </Button>
  </div>
</div>
  
      {/* Contenedor para Tablas Paralelas */}
      <div style={{ display: 'flex', gap: '2rem', marginBottom: '1rem' }}>
        {/* Tabla TSCR */}
        <div style={{ flex: 1, maxHeight: '800px', overflowY: 'auto', border: '1px solid #ccc', padding: '1rem' }}>
          <h3>Disponibles en Tienda</h3>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Codigo</TableCell>
                <TableCell>Descripcion</TableCell> 
                <TableCell>Cantidad Bodega</TableCell> 
                <TableCell>Cantidad Cocina</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {availableItemsTSCR.map((item) => (
                <TableRow key={item.codigo}>
                  <TableCell>{item.codigo}</TableCell>
                  <TableCell>{item.descripcion}</TableCell>
                  <TableCell>{item.cantidadDisponible}</TableCell>
                  <TableCell>{item.cantidadCCO}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
  
        {/* Tabla Productos Agregados */}
        <div style={{ flex: 1, maxHeight: '800px', overflowY: 'auto', border: '1px solid #ccc', padding: '1rem' }}>
          <h3>Productos Agregados</h3>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Código</TableCell>
                <TableCell>Descripción</TableCell>
                <TableCell>Cantidad Transferida</TableCell>
                <TableCell>Acción</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedItems.map((item) => (
                <TableRow key={item.codigo}>
                  <TableCell>{item.codigo}</TableCell>
                  <TableCell>{item.descripcion}</TableCell>
                  <TableCell>{item.cantidadTransferida}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => handleRemove(item.codigo)}
                    >
                      Quitar
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Button
        variant="contained"
        color="success"
        onClick={handleSend}
        disabled={isLoading} // Deshabilitar botón mientras carga
        style={{ marginTop: '1rem' }}
        startIcon={isLoading && <CircularProgress size={20} color="inherit" />} // Spinner en el botón
      >
        {isLoading ? 'Enviando...' : 'Enviar Transferencia'}
      </Button>
        </div>
      </div>
  
      {/* Tabla CCO 
      <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #ccc', padding: '1rem' }}>
        <h3>Disponibles en CCO</h3>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Código</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Cantidad Disponible</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {availableItemsCCO.map((item) => (
              <TableRow key={item.codigo}>
                <TableCell>{item.codigo}</TableCell>
                <TableCell>{item.descripcion}</TableCell>
                <TableCell>{item.cantidadDisponible}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div> 
      */}
    </div>
  );
  
  
};

export default TrasladoBodegaCocina;
